export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-96x96-78fa6fdb9ee24447eec4a3f9b3dac2f0.png";